import { render, staticRenderFns } from "./ProviderUnitEdit.vue?vue&type=template&id=0872f8bd&scoped=true&"
import script from "./ProviderUnitEdit.vue?vue&type=script&lang=js&"
export * from "./ProviderUnitEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProviderUnitEdit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProviderUnitEdit.vue?vue&type=style&index=1&id=0872f8bd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0872f8bd",
  null
  
)

export default component.exports